import React from 'react';
import { Outlet, matchPath, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { BillingNavProvider } from '../../../containers/payment/billing-nav/BillingNavContext';
import { SettingsSidebar } from './SettingsSidebar';
import styles from './SettingsLayout.module.scss';

/** Billing keeps its own card chrome; the rounded-card rule below must not reach it. */
const SETTINGS_CARD_CHROME_EXCLUDED_ROUTE = '/payment/*';

/**
 * Layout route for Account, Team, Billing and Alerts: the settings sidebar beside whichever page
 * the child route resolves to. Lives in the dashboard shell so the sidebar stays put while the
 * lazy page chunks swap underneath it — which is also what lets `BillingNavProvider` resolve the
 * plan once for the whole visit instead of once per page.
 */
export function SettingsLayout() {
  const { pathname } = useLocation();
  const roundedCards = !matchPath(SETTINGS_CARD_CHROME_EXCLUDED_ROUTE, pathname);

  return (
    <BillingNavProvider>
      <div className={styles.layout} data-id='settings-layout'>
        <SettingsSidebar />

        <div
          className={clsx(styles.content, roundedCards && styles.roundedCards)}
          data-id='settings-layout-content'
        >
          <Outlet />
        </div>
      </div>
    </BillingNavProvider>
  );
}
